<zef-dialog
  [open]="state.open"
  [options]="{ restoreFocus: false, disableClose: true, width: '780px' }"
  [autoFocus]="false"
  (closeTrigger)="onClose$.next()">

  <div class="__content">

    <zui-form-section separator="none">
      <span *zuiFormSectionTitle>
        @if (state.isRegenerate) {
          @if (state.isPersonal) {
            Personal token <strong>{{ state.tokenName }}</strong> regenerated
          } @else {
            Integration token <strong>{{ state.tokenName }}</strong> regenerated
          }
        } @else {
          @if (state.isPersonal) {
            Personal token <strong>{{ state.tokenName }}</strong> created
          } @else {
            Integration token <strong>{{ state.tokenName }}</strong> created
          }
        }
      </span>
    </zui-form-section>

    <zui-tip-card
      theme="warning"
      icon="report_problem"
      iconAlignment="start"
      [spacing]="36"
      class="__warning-card">
      <p class="__warning-text">
        @if (state.isRegenerate) {
          This token will only be shown once. The previous token has been invalidated.
        } @else {
          This token will only be shown once. Save it securely before closing.
        }
      </p>
    </zui-tip-card>

    <zef-copy-to-clipboard
      mode="basic"
      [copyData]="state.tokenValue"
      class="__token-copy">
      <div class="__token-box">
        <div class="__token-value">{{ state.tokenValue }}</div>
      </div>
    </zef-copy-to-clipboard>

    <div class="__buttons">
      <button
        mat-flat-button
        color="accent"
        type="button"
        class="c-button--full"
        (click)="onClose$.next()">
        I've saved my token, close
      </button>
    </div>

  </div>

</zef-dialog>
